export const HEADER_HREF = {
	START: 'start',
	VIDEO: 'video',
	ABOUT: 'about',
	FUNCTIONS: 'functions',
	DOWNLOAD: 'download'
};

export const HEADER_BAR_HEIGHT = 91;
